export const shouldUseNewPdfFormat = (
  month: number | string,
  year: number,
  location?: string
): boolean => {
  // month can be number (1-12) or string ("January", "Feb", etc.)
  const monthIndex =
    typeof month === "string"
      ? new Date(`${month} 1, 2000`).getMonth()
      : month - 1;

  const selectedDate = new Date(year, monthIndex);

  // Paris => May 2026
  // Brussels => April 2026
  const cutoffDate =
    location === "Paris"
      ? new Date(2026, 4) // May 2026
      : new Date(2026, 3); // April 2026

  return selectedDate >= cutoffDate;
};

export default shouldUseNewPdfFormat;
